// extracted by mini-css-extract-plugin
module.exports = {"row":"dd31006766--row--2oUmy","row_name":"dd31006766--row_name--3n2KN","row_value":"dd31006766--row_value--2YJiw"};